import React from 'react';
import { differentiators } from '../data/fono';
export function DifferentiatorSection() {
  return <section className="bg-white px-3 py-5 sm:py-7" data-id="element-29" data-mp="3j4h0vpvumb5d">
      <div className="mx-auto max-w-4xl" data-id="element-30" data-mp="3j24ixcq3c0sb">
        <h2 className="text-center text-xl leading-tight text-teal sm:text-3xl" data-id="element-31" data-mp="3558y6n0h8kwf">
          This isn’t just another collection of worksheets
        </h2>
        <p className="mt-1 text-center text-sm font-extrabold uppercase tracking-wide text-coral sm:text-lg" data-id="element-32" data-mp="3a5n6m65zpwuz">
          It’s a complete visual activity system.
        </p>

        <div className="mt-3 grid gap-x-5 gap-y-2.5 sm:grid-cols-2 lg:grid-cols-3" data-id="element-33" data-mp="3064n1qtzsd3g">
          {differentiators.map(item => <div key={item.title} className="flex gap-2.5" data-id="element-34" data-mp="2mbvddaqh9uuj">
              <span className="text-xl leading-none" aria-hidden="true" data-id="element-35" data-mp="2qgct8ytpvo01">
                {item.emoji}
              </span>
              <div data-id="element-36" data-mp="2cgk437xu9fu6">
                <h3 className="text-[13px] leading-tight text-teal sm:text-base" data-id="element-37" data-mp="2ci4qgaa01sgy">
                  {item.title}
                </h3>
                <p className="text-[13px] font-medium leading-snug text-charcoal/80" data-id="element-38" data-mp="15gcqe25rduzu">
                  {item.body}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}